import { render, staticRenderFns } from "./client-trans-coin.vue?vue&type=template&id=9ad4cd1a&"
import script from "./client-trans-coin.vue?vue&type=script&lang=js&"
export * from "./client-trans-coin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports